"use client";

import { FormEvent, useState } from "react";
import Image from "next/image";
import { PhoneNumberUtil } from 'google-libphonenumber';
import Email from "@/public/svg/mail.svg";
import Name from "@/public/svg/name.svg";
import Whatsapp from "@/public/svg/whatsapp.svg";

import Input from "@/components/Input";
import Button from "@/components/button/Button";
import Heading from "@/components/heading/heading";
import Person from "@/public/svg/common/enquire-wizard/number-persons.svg";

import "@/styles/common/form.scss";
import "@/styles/home/form.scss";
import "./customize-packages.scss";

import Successmark from "@/public/svg/success-icon.svg";

import submitFormDetails from "@/utils/services";

import { z } from "zod";
import Select from "@/components/Select";
import PhInput from "@/components/PhInput/PhInput";

const formSchema = {
    name: z.string().min(1, {
        message: "Please enter your name",
    }),
    email: z
        .string()
        .min(1, {
            message: "Please enter your email",
        })
        .email({
            message: "Please enter a valid email",
        }),
    whatsapp: z
        .string()
        .min(5, {
            message: "Please enter your whatsapp number",
        }),
    persons: z
        .number({
            required_error: "Please select number of persons",
        })
        .min(1, {
            message: "Please select number of persons",
        })
        .max(10, {
            message: "Please select number of persons",
        }),
};

const persons = [
    "Select Persons",
    "solo",
    "2 pax",
    "3 pax",
    "4 pax",
    "5 pax",
    "6 pax",
    "7 pax",
    "8 pax",
    "9 pax",
    "10+ pax",
];

const CustomizePackages = () => {
    const [formSubmitStatus, setFormSubmitStatus] = useState(false);
    const [pageUrl,setPageUrl] = useState("");

    const initialState = {
        name: "",
        email: "",
        whatsapp: "",
        countryCode:"",
        persons: 1,
        enqId: new Date().getTime().toString(),
        pageUrl: getCurrentPageUrl(),
    };

    setTimeout(() => {
        console.log("updated after 4sec",);
        setPageUrl(window.location.href);
    }, 4000);

    const [state, setState] = useState(initialState);
    const [errors, setErrors] = useState("");
    const phoneUtil = PhoneNumberUtil.getInstance();

    function getCurrentPageUrl() {
        if (typeof window !== "undefined") {
            // Listen to popstate events (triggered by navigation within the SPA)
            window.onpopstate = function() {
                console.log('Current URL after navigation: ', window.location.href);
            };
    
            // Return the current URL
            return window.location.href;
        }
        return "";
    }
    

    const isPhoneValid = () => {
        const countryCode=state.countryCode.toUpperCase();
        
        try {
          return phoneUtil.isValidNumber(phoneUtil.parse(state.whatsapp, countryCode));
          
        } catch (error) {            
          return false;
        }
      };


    const handleFormSubmit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        const schema = z.object(formSchema);

        const result = schema.safeParse(state);

        if (!result.success) {
            setErrors(result.error.errors[0].message);
            return;
        }


        if(!isPhoneValid()){
            setErrors("Please enter a valid number")
            return;
        }
    
        setErrors("");
        setState(initialState);
        const submissionStatus = await submitFormDetails(state, "Srilanka-Group-Tour");
        setFormSubmitStatus(submissionStatus);
        setTimeout(() => {
            setFormSubmitStatus(false);
        }, 40000);
    };

        const isWhatsappValid = state.whatsapp.length >=10 && isPhoneValid();




    return (
        <div
            className="customize-packages-block p-6 flex flex-col gap-6 enquire-wizard-itinerary"
            id="customizePackages"
        >
            <h3 className="font-yesteryear font-extralight leading-none"> Premium Group Tour</h3>
            <p className="font-bold text-2xl mt-0 blink-me text-red leading-none">Only 15 seats left. Book now!</p>
            {formSubmitStatus ? (
                <div className="enquire-wizard p-6 flex flex-col gap-6 justify-center items-center h-434 lg:h-456">
                    <Image loading="lazy"
                        src={Successmark}
                        alt="Successmark"
                        width={68}
                        height={68}

                    />
                    <h4>Thanks for Submitting the details</h4>
                    <p className="text-center">Check email for day-wise itinerary and estimated pricing. Our travel planner will contact you in 24hrs.</p>
                </div>
            ) : (
                <form
                    id="srilanka-grou-tour-form"
                    className="flex flex-col gap-4 single-form"
                    onSubmit={handleFormSubmit}
                >
                    <Input
                        icon={Name}
                        name="Name"
                        placeholder="Your Name"
                        onChange={(e) => {
                            setState({
                                ...state,
                                name: e.target.value,
                            });
                        }}
                        value={state.name}
                    />
                    <Input
                        icon={Email}
                        name="Email"
                        placeholder="youremail@gmail.com"
                        onChange={(e) => {
                            setState({
                                ...state,
                                email: e.target.value,
                            });
                        }}
                        value={state.email}
                    />
                    <PhInput
                        icon={Whatsapp}
                        name="Whatsapp"
                        placeholder="99999 99999"
                        type="number"
                        onChange={(phone: any) => {
                            setState({ ...state, whatsapp: phone });
                        }}
                        value={state.whatsapp}
                    />
                    {/* <Input
                        icon={Whatsapp}
                        name="Whatsapp"
                        placeholder="99999 99999"
                        type="number"
                        onChange={(e) => {
                            setState({
                                ...state,
                                whatsapp: e.target.value
                            })
                        }}
                        value={state.whatsapp}
                    /> */}
                    <Select
                        icon={Person}
                        name="Number of Persons"
                        options={persons}
                        placeholder="Select Number of Persons"
                        onChange={(e) => {
                            setState({
                                ...state,
                                persons: persons.indexOf(e.target.value),
                            });
                        }}
                        value={persons[state.persons]}
                    />

                    <input
                        type="hidden"
                        name="Enquiry Id"
                        onChange={(e) => { }}
                        value={state.enqId}
                    />
                    <input
                        type="hidden"
                        name="Page Url"
                        onChange={(e) => { }}
                        value={pageUrl}
                    />
                    <div className="error-text text-sm font-medium">
                        {errors}
                    </div>
                    <Button className="flex-center" type="submit" variant="orange" disabled={!isWhatsappValid}>
                        <span>Submit</span>
                    </Button>
                </form>
            )}
        </div>
    );
};

export default CustomizePackages;
